<template>
  <v-container fluid>
    <a-tabs v-model="tabKey" size="small" @change="changeTab">
      <a-tab-pane tab="运营审批" :key="0"></a-tab-pane>
      <a-tab-pane tab="郑州南阳信阳线" :key="1"></a-tab-pane>
      <a-tab-pane tab="郑州商丘开封线" :key="2"></a-tab-pane>
      <a-tab-pane tab="交接班日志" :key="99"></a-tab-pane>
    </a-tabs>
    <!-- 运营审批页面：点击"运营审批"Tab时展示 approval.vue 内容 -->
    <Approval v-if="tabKey === 0" ref="approvalRef" />
    <Log v-else-if="tabKey === 99" ref="logRef" />
    <!-- 派车计划页面 -->
    <DispatchPlan v-else ref="dispatchplanRef" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import Approval from "./approval.vue";
import Log from "./log.vue";
import DispatchPlan from "../dispatchplanv2.vue";
export default {
  name: "Dispatchplan2",
  data() {
    return {
      tabKey: 1,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: { Approval, DispatchPlan, Log },
  watch: {
  },
  mounted() {
  },
  activated() {

  },
  methods: {
    changeTab(v) {
      console.log('changeTab', v);
      this.$nextTick(() => {
        if (v === 0) {
          this.$refs.approvalRef.init();
        }
        else if (v === 99) {
          this.$refs.logRef.init();
        }
        else {
          this.$refs.dispatchplanRef.init(v);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-tabs-bar {
  margin: 0 !important;
}
</style>